/** Individual steps of the login procedure. */
export var LoginStep;
(function (LoginStep) {
    /**
     * User is asked to enter the their username. If their organization has SAML
     * configured the user will instead be redirected to the login page of their
     * identity provider. If not move on to step 2.
     */
    LoginStep[LoginStep["USERNAME"] = 0] = "USERNAME";
    /**
     * User is asked to enter a password. If the credentials (username and
     * password) are valid the they will be logged in and redirected to the
     * welcome page. If 2FA is enabled they will instead move to step 3.
     */
    LoginStep[LoginStep["PASSWORD"] = 1] = "PASSWORD";
    /**
     * User is asked for two factor confirmation. If a valid token is
     * provided they will be logged in and redirect to the welcome page.
     */
    LoginStep[LoginStep["TWO_FACTOR"] = 2] = "TWO_FACTOR";
})(LoginStep || (LoginStep = {}));
